import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {
  userTab: boolean;
  allTab: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.allTab = false;
    this.userTab = false;

    if (number == '1') {
      this.allTab = true;
    }
    else if (number == '2') {
      this.userTab = true;
    }

  }

}
